import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { Subscription } from 'rxjs';
import { AppStateService } from 'src/app/Services/AppState/app-state.service';
import { TourController, TourStep } from 'src/assets/js/Tour/Tour';
import { RouterModule } from '@angular/router';
enum Tour {
  STEP_ONE = 'step1',
  STEP_TWO = 'step2'

}
@Component({
  selector: 'app-product-access',
  templateUrl: './product-access.component.html',
  styleUrls: ['./product-access.component.scss'],
  standalone: true,
  imports: [
    MatIconModule
    , MatTableModule
    , MatSlideToggleModule
    , RouterModule
  ]
})
export class ProductAccessComponent implements OnInit, OnDestroy {
  public displayedColumns: string[] = ["col1", "col2", "col4"];
  step1 = Tour.STEP_ONE;
  step2 = Tour.STEP_TWO;
  public tour: TourController;
  private productsSubscription!: Subscription;
  constructor(public appStateService: AppStateService) {
    this.tour = new TourController();
  }
  ngOnDestroy(): void {
    this.productsSubscription.unsubscribe();
  }

  ngOnInit(): void {
    this.appStateService.cleanPaginator();
    this.onActualizar();
  }

  onActualizar = () => {
    this.productsSubscription = this.appStateService.ProductService.GetProductsAccessControl()
      .subscribe();
  };

  statusClass = (status: Boolean) => !status && 'pending' || 'finalized';

  slideChanged(productID: string, adminAccess: boolean) {
    this.productsSubscription =  this.appStateService.ProductService
    .SetProductsAccessControl(productID, adminAccess)
    .subscribe(() => {
      this.onActualizar();
    });
  }

  onStartTour() {
    const steps: TourStep[] = [
      {
        element: `#${this.step1}`,
        title: 'Configuraciones',
        content: 'En esta pantalla, puedes configurar los accesos a productos para que solo sean accesibles por los administradores.',
      },
      {
        element: `#${this.step1}`,
        title: 'Acceso de administrador',
        content: 'Habilita permisos con un solo clic ajustando el nivel de acceso.',
      },
    ];


    this.tour.onConfigTour(steps);
    this.tour.onStartTour();
  }
}
